import React from 'react';
import axios from 'axios';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

jest.mock('axios');

describe('OperationHistories', () => {
  describe('Index', () => {
    test('renders', async() => {

      const promise = Promise.resolve({
        data: {
          d_operation_histories: [
            {id: 1, view_created_at: "2024年03月15日 14時45分10秒", message: "メッセージ1"},
            {id: 2, view_created_at: "2024年03月15日 13時45分10秒", message: "メッセージ2"},
            {id: 3, view_created_at: "2024年03月15日 12時45分10秒", message: "メッセージ3"}
          ]
        }
      });
      
      (axios.get as any).mockResolvedValue(promise);

      render(<Index screens={[{value: "1", label: "画面1"}, {value: "2", label: "画面2"}]} operations={[{value: "1", label: "操作１"}, {value: "2", label: "操作２"}]} m_users={[{value: "1", label: "テスト太郎"}, {value: "2", label: "テスト二郎"}]}/>);

      await act(() => promise);

      // タイトル
      expect(screen.getByRole("heading", {name: "操作履歴"})).toBeInTheDocument();

      // 検索エリア
      expect(screen.getByRole("columnheader", {name: "操作日付"})).toBeInTheDocument();
      expect(screen.getByText("操作画面名")).toBeInTheDocument();
      expect(screen.getByText('操作内容')).toBeInTheDocument();
      expect(screen.getByText('操作ユーザー')).toBeInTheDocument();
      expect(screen.getByRole("button", {name: "検索"})).toBeInTheDocument();

      // 表示エリア
      expect(screen.getByRole("row", {name: "操作日付 メッセージ"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "2024年03月15日 14時45分10秒 メッセージ1"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "2024年03月15日 13時45分10秒 メッセージ2"})).toBeInTheDocument();
      expect(screen.getByRole("row", {name: "2024年03月15日 12時45分10秒 メッセージ3"})).toBeInTheDocument();

      screen.debug();
    });  
  }); 
});

